import { Flex, Text } from '@chakra-ui/react';
import { DocumentCategory } from '@client/graphql/__generated__/types';
import { Select } from '@document/common/Select';

interface DataToShareSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
}

interface DataOption {
  value: string;
  label: string;
}

const DATA_OPTIONS: DataOption[] = [
  { value: DocumentCategory.PROPERTY_PURCHASE, label: 'Purchase Contract' },
  { value: DocumentCategory.OFFER_AMENDMENT, label: 'Offer Amendment' },
  { value: DocumentCategory.COUNTER_OFFER, label: 'Counter Offer' },
  { value: 'KeyTerms', label: 'Key Terms' },
];

const darkSelectStyles = {
  container: (provided: Record<string, unknown>) => ({
    ...provided,
    minWidth: '250px',
    maxWidth: '450px',
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean; isFocused: boolean }
  ) => ({
    ...provided,
    bg: state.isSelected
      ? 'whiteAlpha.200'
      : state.isFocused
        ? 'whiteAlpha.100'
        : 'transparent',
    color: 'white',
    _hover: { bg: 'whiteAlpha.100' },
  }),
  singleValue: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'white',
  }),
};

export const DataToShareSelect = ({
  value,
  onChange,
}: DataToShareSelectProps) => {
  const selectedOptions = DATA_OPTIONS.filter((opt) =>
    value.includes(opt.value)
  );

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="whiteAlpha.100"
      justifyContent="space-between"
      py={5}
    >
      <Text color="whiteAlpha.700">Data to be shared</Text>
      <Select<DataOption, true>
        isMulti
        chakraStyles={darkSelectStyles}
        closeMenuOnSelect={false}
        getOptionLabel={(opt) => opt.label}
        getOptionValue={(opt) => opt.value}
        isSearchable={false}
        options={DATA_OPTIONS}
        placeholder="None"
        value={selectedOptions}
        onChange={(newValue) => {
          onChange(newValue.map((opt) => opt.value));
        }}
      />
    </Flex>
  );
};
